import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { ChatContainer } from '@/components/chat/ChatContainer';

export function ChatPage() {
  return (
    <div className="flex flex-col h-screen overflow-hidden">
      <Header />

      {/* Spacer for fixed header */}
      <div className="h-[56px] md:h-[64px] flex-shrink-0" />

      {/* Main content */}
      <main className="flex-1 min-h-0 relative">
        <ChatContainer />
      </main>

      <Footer />
      {/* Spacer for fixed footer on desktop */}
      <div className="hidden md:block h-[48px] flex-shrink-0" />
    </div>
  );
}
